import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Input } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import CrossButton from '@/components/buttons/CrossButton';
import TickButton from '@/components/buttons/TickButton';
import ValidationSpan from '@/components/errors/ValidationSpan';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { hideEditActiveLookup, updateActiveLookupProperties } from '../../dictionaries/actions';
import { validateLookup } from '../helper';

const DictionaryLookupEditor = ({
  cancelable,
  dictionary,
  hideUpdate,
  newName,
  oldName,
  saveErrors,
  updateProperties,
}) => {
  const intl = useIntl();
  const setErrors = (newErrors) => (updateProperties({ saveErrors: newErrors }));

  const validateForm = () => {
    const validationErrors = [];
    validateLookup(dictionary, validationErrors, intl, oldName, newName);

    return validationErrors;
  };

  const nameChange = (e) => {
    setErrors([]);
    updateProperties({ name: e.target.value });
  };

  const checkForErrors = () => {
    const validationErrors = validateForm();
    setErrors(validationErrors);

    return validationErrors;
  };

  const submitForm = () => {
    const validationErrors = checkForErrors();

    if (validationErrors.length === 0) {
      hideUpdate(false);
    }
  };

  const nameError = findError(saveErrors, 'dictionary', [fields.NAME]);

  return (
    <div className="aridhia-dictionary-lookup-dialog__input-container">
      <ValidationSpan validationError={nameError} />
      <Input
        autoFocus
        fluid
        labelPosition="right"
        className={validationClasses(nameError)}
        label={(
          <Button.Group icon compact>
            <TickButton disabled={!hasMinimumLength(newName)} onClick={submitForm} />
            {cancelable && (<CrossButton onClick={() => hideUpdate(true)} />)}
          </Button.Group>
                )}
        type="text"
        placeholder={intl.formatMessage({ id: 'dataset.dictionary.lookup.name.placeholder' })}
        value={newName}
        maxLength={globalFieldLengths.name}
        onChange={nameChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            submitForm();
          }
        }}
      />
    </div>
  );
};

const mapStateToProps = ({
  datasets: {
    lookups,
  },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const items = dictionary ? dictionary.lookups || {} : {};

  return (
    {
      cancelable: Object.keys(items).length > 0,
      dictionary,
      newName: lookups.lookupBeingEdited.name,
      oldName: lookups.lookupBeingEdited.isNew ? null : lookups.activeLookupName,
      saveErrors: lookups.lookupBeingEdited.saveErrors,
    }
  );
};

const mapDispatchToProps = {
  hideUpdate: hideEditActiveLookup,
  updateProperties: updateActiveLookupProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryLookupEditor);
